// @flow
import React from 'react';
import ContentText from 'Components/ContentText';
import DealerModel from 'Stores/DealerModel';
import { getGivenBackground } from 'Utils/getColor/index';

type Props = {
  dealer: DealerModel,
  wizard?: boolean,
};

export default class Imprint extends React.Component<Props> {
  renderImprintData(dealer: DealerModel) {
    return (
      <div>
        <h2 className="h4">Verantwortliche Stelle 1:</h2>
        <p>Mazda Motors (Deutschland) GmbH</p>
        <p>Hitdorfer Straße 73</p>
        <p>51371 Leverkusen</p>
        <p>
          Tel. <a href="tel:021739430">02173 - 943 0</a>
        </p>
        <p>
          <a href="mailto:info@mazda.de">info@mazda.de</a>
        </p>
        <br />
        <p>
          Geschäftsführer: Bernhard Kaplan, Colin Maddocks, Giovanni Barbieri, Wojciech Halarewicz.
        </p>
        <p>Amtsgericht Köln, HRB 48377</p>
        <p>Ust-ID-Nr.: DE 1237 1888 0</p>
      </div>
    );
  }

  render() {
    const { dealer, wizard } = this.props;

    if (wizard) {
      return this.renderImprintData(dealer);
    }

    return (
      <ContentText background={getGivenBackground('white')}>
        {this.renderImprintData(dealer)}
        <br />
        <br />
        <p>
          Hinweis gemäß §36 Verbraucherstreitbeilegungsgesetz (VSBG):
          <br />
          Mazda Motors (Deutschland) GmbH wird nicht an einem Streitbeilegungsverfahren vor einer
          Universalschlichtungsstelle im Sinne des VSBG teilnehmen und ist hierzu auch nicht
          verpflichtet.
        </p>
      </ContentText>
    );
  }
}
